import { render, staticRenderFns } from "./IncomeCost.vue?vue&type=template&id=e3888e24&scoped=true&"
import script from "./IncomeCost.vue?vue&type=script&lang=js&"
export * from "./IncomeCost.vue?vue&type=script&lang=js&"
import style0 from "./IncomeCost.vue?vue&type=style&index=0&id=e3888e24&scoped=true&lang=css&"
import style1 from "./IncomeCost.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3888e24",
  null
  
)

export default component.exports